export default "__VITE_ASSET__DNSfYrJz__"